import { createSlice } from "@reduxjs/toolkit";

export const overtimeReducer = createSlice({
  name: "overtime",
  initialState: [
    // id: "",
    // projectType: "",
    // subProjectType: "",
    // leaveType: "",
    // instructedBy: "",
    // position: "",
    // variationOrderNo: "",
    // dateOfObservation: null,
    // overtimeEntries: [],
    // attachedFile: [""],
    // additionalNotes: "",
    // status: "",
    // type: "overtime",
    // isDraft: false,
  ],
  reducers: {
    addOvertime: (state, action) => {
      console.log("Adding Overtime:", action.payload); // Log the action payload
      state.push(action.payload);
      console.log("Updated Overtime State:", state); // Log the new state after adding overtime
    },
    updateOvertime: (state, action) => {
      const index = state.findIndex(
        (overtime) => overtime.id === action.payload.id,
      );
      if (index !== -1) {
        console.log("Updating Overtime with ID:", action.payload.id); // Log the overtime ID being updated
        state[index] = action.payload;
        console.log("Updated Overtime Entry:", state[index]); // Log the updated overtime entry
      } else {
        console.log("Overtime ID not found for update:", action.payload.id); // Log if overtime ID is not found
      }
    },
    removeOvertime: (state, action) => {
      console.log("Removing Overtime with ID:", action.payload.id); // Log the overtime ID being removed
      const newState = state.filter(
        (overtime) => overtime.id !== action.payload.id,
      );
      console.log("Updated Overtime State after removal:", newState); // Log the new state after removal
      return newState;
    },
    clearOvertime: () => {
      console.log("Clearing all Overtime entries"); // Log the clearing action
      return []; // Return an empty array, clearing all overtime entries
    },
  },
});

export const { addOvertime, updateOvertime, removeOvertime, clearOvertime } =
  overtimeReducer.actions;

export default overtimeReducer.reducer;
